import React from 'react';
import styled from 'styled-components';

import { Paper } from '@material-ui/core';
import IconBorder from 'components/shared/IconBorder';
import { ReactComponent as VerseIcon } from 'assets/images/verse-logo.svg';

const Wrapper = styled(Paper)`
  && {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: ${(props) => props.theme.spacing(1, 3)};
  }
`;

const IconWrapper = styled('div')`
  bottom: 0;
  align-self: flex-start;
  margin-left: ${(props) => props.theme.spacing(-20)};
  margin-bottom: ${(props) => props.theme.spacing(-20)};

  .verse-icon-wrapper {
    padding: ${(props) => props.theme.spacing(5)};

    svg {
      padding-left: ${(props) => props.theme.spacing(10)};
      padding-bottom: ${(props) => props.theme.spacing(10)};
    }
  }
`;

interface TransitionScreenProps {
  children: React.ReactNode;
}

const TransitionScreen = ({ children }: TransitionScreenProps) => {
  return (
    <Wrapper square>
      {children}
      <IconWrapper>
        <IconBorder className="verse-icon-wrapper" boxShadow>
          <VerseIcon height="40rem" />
        </IconBorder>
      </IconWrapper>
    </Wrapper>
  );
};

export default TransitionScreen;
